import "./style.css";
import { useTranslation } from "../../i18n/LanguageContext";

const TermsOfUse = () => {
    const { t } = useTranslation();
    return (
        <div className="main-content-wrapper">
            <div className="termsOfUsePage">
                <h2>{t("legal.terms")}</h2>
                <p>{t("legal.updated")}</p>
                <p>{t("terms.intro")}</p>
                {t("terms.sections").map((s, i) => (
                    <div key={i}>
                        <h4>{s.h}</h4>
                        <p>{s.t}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TermsOfUse;
